import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './api/auth';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { AuditPage } from './pages/AuditPage';
import { CardsPage } from './pages/CardsPage';
import { ConfigPage } from './pages/ConfigPage';
import { DiseasesPage } from './pages/DiseasesPage';
import { LoginPage } from './pages/LoginPage';
import { OrgansPage } from './pages/OrgansPage';
import { UsersPage } from './pages/UsersPage';
import { WheelPage } from './pages/WheelPage';

function Shell() {
  const { admin, loading } = useAuth();

  // Until the stored token has been checked, rendering either the panel or the
  // login form would be a guess — one of them would flash and then swap.
  if (loading) return <div className="login"><Spinner label="Checking your session…" /></div>;
  if (!admin) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/organs" element={<OrgansPage />} />
        <Route path="/diseases" element={<DiseasesPage />} />
        <Route path="/wheel" element={<WheelPage />} />
        <Route path="/cards" element={<CardsPage />} />
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="*" element={<Navigate to="/organs" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
